import { ADMIN_VERSION_LSK } from 'app.constants'

// an interface declaration to handle the window.shopId type:
declare global {
    interface Window {
        adminVersion: string | undefined
    }
}

//getAdminVersion:
export const getAdminVersion = () => {
    let adminVersion = 'v2'
    try{
        adminVersion = localStorage.getItem(ADMIN_VERSION_LSK) ?? 'v2'
    }catch(e){
        adminVersion = window.adminVersion ?? 'v2'
    }
    return adminVersion
}

//updateAdminVersion:
export const updateAdminVersion = (version: 'v1' | 'v2') => {
    if(getAdminVersion() !== version){
        try{
            localStorage.setItem(ADMIN_VERSION_LSK, version)
            location.reload()
        }catch(e){
            window.adminVersion = version
        }
    }
}
